/* global gtag */

export default {
  event(category, action = '(not set)', label = '(not set)', value = '(not set)') {
    gtag('event', action, {
      event_category: category,
      event_label: label,
      value,
    });
  },

  timing(naming, value) {
    gtag('event', 'timing_complete', {
      name: naming,
      value,
    });
  },
};
